import { createPortal } from 'react-dom';

import { Box, Button, Tooltip } from '@mui/material';

import ActionTooltipBody from './ActionTooltipBody';

type Props = {
  title: string;
  children: React.ReactElement<any, any>;
  time?: string;
  open: boolean;
  actionButtons: {
    label: string;
    variant?: 'outlined' | 'contained';
    onClick: () => void;
  }[];
  handleClose: () => void;
};

export default function ActionTooltip({
  children,
  open,
  title,
  actionButtons,
  handleClose
}: Props) {
  return (
    <>
      {/* Backdrop */}
      {open &&
        createPortal(
          <Box
            draggable={false}
            onClick={handleClose}
            sx={{
              backgroundColor: 'rgba(0,0,0,0.75)',
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: 100,
              width: '100vw',
              height: '100vh',
              transitionDuration: '250ms'
            }}
          />,
          document.body
        )}

      {/* Tooltip */}
      <Tooltip
        arrow
        placement="top"
        open={open}
        title={
          <ActionTooltipBody title={title} onClose={handleClose}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              mt={1}
              gap={1}
            >
              {actionButtons.map(({ label, variant, onClick }) => (
                <Button
                  key={label}
                  sx={{ fontSize: '11px' }}
                  variant={variant || 'outlined'}
                  size="small"
                  onClick={onClick}
                >
                  {label}
                </Button>
              ))}
            </Box>
          </ActionTooltipBody>
        }
      >
        {children}
      </Tooltip>
    </>
  );
}
